import CreateImpactsContainer from "../containers/CreateImpactsContainer";

const CreateImpactsPage = () => {
  return (
    <CreateImpactsContainer />
  );
};

export default CreateImpactsPage;
